<template> 
    <div class="copybox" @click="toBusinessInfo">
      <img class="copyImg" src="https://static.dierqudao.com/images/bg-copyright@2x.png" />
      <div class="copytitlebox">
        <!--            <span class="copytext">「第二渠道」提供技术运营方案</span>-->
        <span class="copytext">我也要开店</span>
      </div>
    </div> 
</template>

<script>
export default {
  name: "CopyRight",
  data: function() {
    return {
      bookShow: false,
      showConfirmButton: false,
      closeOnClickOverlay: true
    };
  },
  methods: {
    toBusinessInfo() {
      rbLink({
        name: 'BusinessForm',
        query: {  }
      });
      
    },
    // toFenxiaoPoster() {
    //   this.$router.push({
    //     name: "FenxiaoPoster"
    //   });
    // }
  }
};
</script>

<style scoped>
.copybox {
  text-align: center;
  margin-top: 10px;
}
.copyImg {
  width: 130px;
  height: 31px;
}

.copytitlebox {
  text-align: center;
}

.copytext {
  font-size: 11px;
  font-family: PingFangSC-Regular;
  font-weight: 400;
  color: rgba(153, 153, 153, 1);
  line-height: 28px;
}
</style>



// WEBPACK FOOTER //
// CopyRight.vue?d61a3b00